import { applyRealityCheckQueries, QueryBuilder } from "./Helpers";
export const RealityCheckConnection = {
    getSettings() {
        return applyRealityCheckQueries(QueryBuilder.getSettings());
    },
    saveSettings(settings) {
        return applyRealityCheckQueries(QueryBuilder.saveSettings(settings));
    },
    getWageringInformation() {
        return applyRealityCheckQueries(QueryBuilder.getWageringInformation());
    }
};
//# sourceMappingURL=RealityCheckConnection.js.map